module.exports = __webpack_public_path__ + "img/xianmi5kg_2.72e4beca.jpg";